<template>
<div class="d-inline-block" :class="[shadow_cls]">
    <img 
        v-if="space.client_logo" 
        class="client-space-logo-img rounded fit-contain"
        :style="{'max-width': `${size}px`, 'max-height': `${size}px`}"
        :src="logo_url" 
    />
    <div v-else class="client-space-logo-initials rounded bg-gradient-secondary d-flex align-items-center justify-content-center fh fw" :class="[initials_size_cls]">
        <div :style="{'font-size': `${initials_font_size}em`}">{{ client_name_initials }}</div>
    </div>
</div>

</template>
<script lang="js">
/**
 * Displays the logo of a Client Space, one of the following:
 * 
 * - Custom image that was uploaded
 * - A built-in logo
 * - Initials of the client name
 * 
 */
const VALID_SIZES = [8, 16, 24, 32, 40, 48, 64, 80, 96, 128]

import { ClientSpacesService } from '@/services/client_spaces-service'
import { Utils } from '@/helpers/utils'

export default {
    props: {
        space: Object,
        size: {
            type: Number,
            default: 48
        }
    },

    data(){
        return {
            ClientSpacesService: ClientSpacesService,
            Utils: Utils
        }
    },

    created(){
        if(!VALID_SIZES.includes(this.size)) throw `Client logo size cannot be ${this.size} px, use one of: ${VALID_SIZES}`
    },

    computed: {
        client_name_initials(){
            // Max 3-letter initials of client name
            return this.space.client_name.split(' ').map(frag => frag.length > 0 ? frag[0].toUpperCase() : '').splice(0,3).join('')
        },

        logo_url(){
            // 
            return this.space.client_logo
                ? ClientSpacesService.is_skyflok_logo(this.space) ? Utils.client_space_logo_src(this.space.client_logo) : this.space.client_logo
                : null
        },

        initials_size_cls(){
            return `thumb${this.size}`
        },

        
        shadow_cls(){
            let shadow_size = 1
            if(this.size > 48) shadow_size = 2
            if(this.size >= 80) shadow_size = 3

            return `shadow-z${shadow_size}`
        },

        initials_font_size(){
            let size_em = 1
            if(this.size > 48) size_em = 1.5
            if(this.size >= 80) size_em = 2.5

            return size_em
        }
    }
}
</script>
<style lang="css" scoped>
.client-space-logo-img{ background-color: white }/* Set solid BG color for built-in png logos */
.theme-dark .client-space-logo-img,
.theme-ironshard .client-space-logo-img{
    background-color: #535353
}

.client-space-logo-initials{color: white}
.theme-dark .client-space-logo-initials,
.theme-ironshard .client-space-logo-initials{
    color: #535353
}

</style>